/**
 * Every tool the Ask Plato agent can call, by name. `AiChatToolMeta.name` is
 * typed against this list, so a new tool must be added here before it
 * compiles — and the client's caption map (features/ai-chat) is typed against
 * the same union, so the new tool cannot ship without captions either.
 */
export const aiChatToolNames = [
    'find_plato_page',
    'get_customer_details',
    'get_customer_financials',
    'get_customer_notes',
    'get_customer_segment_aggregates',
    'get_daily_order_intake',
    'get_data_freshness',
    'get_monthly_trend',
    'get_note',
    'get_pinned_customer_notes',
    'get_quotes_orders_aggregates',
    'get_revenue_by_year',
    'get_sales_summary',
    'get_sales_totals',
    'get_team_members',
    'get_team_overview',
    'get_team_stats',
    'get_top_categories',
    'get_top_clerks',
    'get_top_customers',
    'get_top_industries',
    'get_top_product_groups',
    'get_top_products',
    'get_top_sales_reps',
    'get_top_storage_locations',
    'get_top_suppliers',
] as const;

export type AiChatToolName = (typeof aiChatToolNames)[number];
